import { useTranslation } from 'react-i18next';

import { Transition } from '@headlessui/react';
import { FlagIcon } from '@heroicons/react/24/outline';

const PreviewBanner = () => {
  const { t } = useTranslation();

  return (
    <div className="absolute left-0 top-0 z-20 w-full">
      <Transition
        show={true}
        enter="transition ease-in-out duration-100 transform"
        enterFrom="transform -translate-y-2"
        enterTo="transform opacity-100 ranslate-y-0"
        leave="transition duration-75 ease-out"
        leaveFrom="transform"
        leaveTo="transform"
      >
        <div className="inline-flex h-12 w-full items-center px-2 text-wt-primary">
          <div className="absolute inset-0 bg-wt-primary opacity-10" />
          <div className="mx-auto flex w-full max-w-4xl items-center justify-center">
            <div>
              <FlagIcon className="h-6 w-6" aria-hidden="true" />
            </div>
            <p className="sm:text-md ml-2 truncate px-4 text-sm font-medium">
              <span className="">{t('forms.preview_banner')}</span>
            </p>
          </div>
        </div>
      </Transition>
    </div>
  );
};

export default PreviewBanner;
